import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '@nexus/fff-ui-shared/Button';
import Toast from '@nexus/fff-ui-shared/Toast';

import CategoryModal from './CategoryModal';
import CampaignList from '../CampaignList/CampaignList';
import CategoriesSection from '../Categories/Categories';

const getCampaign = (campaigns, campaignId) => {
  const id = Number(campaignId);
  return campaigns.find((campaign) => campaign.id === id);
};

const CategoryManagement = ({
  categories,
  campaigns,
  fetching,
  getAllCategories,
  getCategoriesCampaign,
}) => {
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState('');
  const campaign = useMemo(() => getCampaign(campaigns, selectedCampaign), [
    selectedCampaign,
  ]);

  const handleNewCategoryButton = () => {
    setIsCategoryModalOpen(true);
  };
  const handleChangeCampaign = (event) => {
    setSelectedCampaign(event.target.value);
    getCategoriesCampaign(event.target.value);
  };

  return (
    <>
      <div className="category-form-container">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h1>Category Management</h1>
          <Button variation="primary" onClick={handleNewCategoryButton}>
            New Category
          </Button>
        </div>
      </div>
      <CampaignList
        campaigns={campaigns}
        selectedCampaign={selectedCampaign}
        handleChangeCampaign={handleChangeCampaign}
      />
      <CategoriesSection campaign={campaign} isLoading={fetching} />
      <CategoryModal
        isOpen={isCategoryModalOpen}
        categories={categories}
        onClickClose={() => setIsCategoryModalOpen(false)}
        getAllCategories={getAllCategories}
      />
      <Toast />
    </>
  );
};

CategoryManagement.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  campaigns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  fetching: PropTypes.bool.isRequired,
  getAllCategories: PropTypes.func.isRequired,
  getCategoriesCampaign: PropTypes.func.isRequired,
};

export default CategoryManagement;
